<div class="notification-form">
    <form (ngSubmit)="onClickSave()" novalidate [formGroup]="notificationForm">
        <div class="required">Required *</div>
        <div>
            <mat-form-field class="send-notification__title" fxFlex="90%">
                <label>
                    <input
                        matInput
                        trimInput
                        type="text"
                        placeholder="Title"
                        formControlName="title"
                    />
                </label>
                <mat-error
                    print-error
                    [control]="notificationForm.get('title')"
                    fieldName="Title"
                >
                </mat-error>
            </mat-form-field>
        </div>

        <div>
            <div class="quill-body" fxFlex="90%">
                <quill-editor
                    placeholder="Message Body *"
                    [modules]="modules"
                    [required]="true"
                    [modules]="modules"
                    formControlName="body"
                ></quill-editor>
                <mat-error
                    print-error
                    [control]="notificationForm.get('body')"
                    fieldName="Message Body"
                >
                </mat-error>
            </div>
        </div>

        <div flex-wrap="wrap" fxLayout="row wrap" fxLayoutAlign="start center">
            <div
                class="send-notification__displayAt"
                style="margin-right: 12px"
            >
                <mat-form-field
                    class="date-field"
                    (click)="$event.stopPropagation()"
                >
                    <input
                        matInput
                        readonly
                        placeholder="Display Date"
                        formControlName="displayAt"
                        [owlDateTimeTrigger]="displayDatePicker"
                        [owlDateTime]="displayDatePicker"
                    />
                    <owl-date-time
                        #displayDatePicker
                        [hour12Timer]="true"
                        [stepMinute]="5"
                    ></owl-date-time>
                </mat-form-field>
                <div class="optionalLabel">(Optional)</div>
            </div>
            <div class="send-notification__expireAt">
                <mat-form-field
                    class="date-field"
                    (click)="$event.stopPropagation()"
                >
                    <input
                        matInput
                        readonly
                        placeholder="Expiration Date"
                        formControlName="expireAt"
                        [owlDateTimeTrigger]="expireDatePicker"
                        [owlDateTime]="expireDatePicker"
                    />
                    <owl-date-time
                        #expireDatePicker
                        [hour12Timer]="true"
                        [stepMinute]="5"
                    ></owl-date-time>
                </mat-form-field>

                <div class="optionalLabel">(Optional)</div>
            </div>
        </div>

        <mat-action-row>
            <div fxLayout="row" fxLayoutAlign="end" fxFill fxFlex="100">
                <button
                    mat-raised-button
                    type="button"
                    (click)="onClickCancel()"
                    class="icon-only"
                >
                    <mat-icon aria-label="Cancel">cancel</mat-icon>
                </button>

                <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    [disabled]="notificationForm.invalid || working"
                >
                    <mat-icon aria-label="Reply">save</mat-icon>
                </button>
            </div>
        </mat-action-row>
    </form>
</div>
